var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showImage)?_c('div',{attrs:{"id":"base"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"surway"},[_c('h6',{attrs:{"data-tally-open":"wQ02R1","data-tally-hide-title":"1","data-tally-emoji-text":"👋","data-tally-emoji-animation":"wave"}},[_vm._v("👋")])])
}]

export { render, staticRenderFns }